import React from "react";
import {
  ThemeProvider,
  CssBaseline,
  Box,
  Typography,
  Card,
  CardContent,
  CardActionArea,
} from "@mui/material";
import {
  LocalShipping as ShippingIcon,
  AutoAwesome as AutoAwesomeIcon,
  Timeline as TimelineIcon,
} from "@mui/icons-material";
import { theme } from "../theme";

interface Product {
  id: string;
  name: string;
  description: string;
  icon: React.ReactNode;
}

const products: Product[] = [
  {
    id: "demoShipmentFeed",
    name: "Demo Shipment Feed",
    description: "Track shipments, view timeline events, and manage reminders from your emails.",
    icon: <ShippingIcon sx={{ fontSize: 48, color: "primary.main" }} />,
  },
  {
    id: "emailAutomation",
    name: "Email Automation",
    description: "AI-powered insights, summaries, and suggested actions from your emails.",
    icon: <AutoAwesomeIcon sx={{ fontSize: 48, color: "primary.main" }} />,
  },
  {
    id: "shipmentTimelineAndAutomation",
    name: "Shipment Timeline",
    description: "View the full shipment email timeline with thread lanes.",
    icon: <TimelineIcon sx={{ fontSize: 48, color: "primary.main" }} />,
  },
];

interface ProductListPageProps {
  onProductSelect: (productId: string) => void;
}

export const ProductListPage: React.FC<ProductListPageProps> = ({ onProductSelect }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ p: 2 }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Dobby for Outlook
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Select a product to get started
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {products.map((product) => (
            <Card key={product.id} elevation={2}>
              <CardActionArea onClick={() => onProductSelect(product.id)}>
                <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 72,
                      height: 72,
                      borderRadius: 2,
                      bgcolor: "action.hover",
                    }}
                  >
                    {product.icon}
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6" fontWeight="medium">
                      {product.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {product.description}
                    </Typography>
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </Box>

      </Box>
    </ThemeProvider>
  );
};
